var React = require('react');

function ArrowRightYellow (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",null,React.createElement("image",{"width":"36","height":"9","xlinkHref":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAJCAYAAABaMo5wAAAAgElEQVQ4T82UIRKDUAwFN+ZjEL0SWHqGXgLTGg5UU1ccHlFV17OQ/xg6MK1Bh8iY3XnzEiNodCd5yZBFmxrGTcOCfL5Y77lK3HKmTmdeyy5U6E+qdVEXDW/Tg1NkSgt7SnRmXFxUNj1RtNDKd8HneAlFp7MW+9ehSKFDXdneH5oBhVE/R4JVO3oAAAAASUVORK5CYII="}))));
}

ArrowRightYellow.defaultProps = {"width":"36","height":"9","viewBox":"0 0 36 9"};

module.exports = ArrowRightYellow;

ArrowRightYellow.default = ArrowRightYellow;
